<template>
  <v-card
    v-if="user && support_dialog"
    class="dialog-contents"
    :style="{ bottom: $vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '8px' : '' }"
  >
    <v-bottom-sheet v-model="sheet">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on.native="on"
          class="dialog-btn"
        >
          <v-icon class="mr-1" size="16">mdi-help-circle-outline</v-icon>
          {{ $t("message.support.title") }}
          <v-icon
            v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
            class="mb-0 dialog-close"
            size="16"
            color="white"
            @click.native="cancel">
            mdi-close
          </v-icon>
        </v-btn>
      </template>
      <v-list>
        <template v-for="item in items">
          <template v-if="item.route">
            <v-list-item
              v-if="(!item.requiresAuth || user)
                && (item.invalid_domains.length === 0 || (user && item.invalid_domains.indexOf(user.domain) < 0))
                && (!item.role || (user && item.role === user.role))
                && $t('message.support.' + item.title) !== ''"
              :key="item.title"
              @click="popup(item.route)"
              target="_blank"
            >
              <v-list-item-avatar>
                <v-avatar
                  size="32"
                  tab>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-title>{{ $t("message.support." + item.title) }}</v-list-item-title>
            </v-list-item>
          </template>
          <template v-else>
            <v-list-item
              v-if="(!item.requiresAuth || user)
                && ($store.getters.user && item.invalid_domains.indexOf($store.getters.user.domain) < 0)
                && (!item.role || ($store.getters.user && item.role === $store.getters.user.role))
                && $t('message.support.' + item.title) !== ''"
              :key="item.title"
              :href="!!item.link ? item.link : null"
            >
              <v-list-item-avatar>
                <v-avatar
                  size="32"
                  tab>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-title>{{ $t("message.support." + item.title) }}</v-list-item-title>
            </v-list-item>
          </template>
        </template>
      </v-list>
    </v-bottom-sheet>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'supportWidget',
  data: function(){
    return {
      module_id: "XX",
      support_dialog: true,
      sheet: false
    }
  },
  computed: {
    ...mapGetters([
      'user',
    ]),
    items: function(){
      return [
        {
          "icon": "mdi-book-open-variant",
          "title": "manual",
          "requiresAuth": true,
          "invalid_domains": [],
          "route": "https://www.rozetta.jp/lp/t3mt/manual/" + this.$i18n.locale + "/user/" + this.$store.getters.domain + "/top.html",
          "title": "user_operation",
        },
        {
          "icon": "mdi-book-open-variant",
          "route": "https://www.rozetta.jp/lp/t3mt/manual/" + this.$i18n.locale + "/manager/t-3mt/top.html",
          "title": "manager_operation",
          "invalid_domains": [],
          "role": "organization_manager"
        },
        {
          "icon": "mdi-book-open-variant",
          "route": this.$store ? "/v" + this.$store.getters.api_version + "/manual/" + this.$i18n.locale + "/manager/" + this.$store.getters.domain + "/top.html" : '',
          "title": "manager_operation",
          "invalid_domains": [],
          "role": "group_manager",
        },
        {
          "icon": "mdi-youtube",
          "title": "movie",
          "route": "https://www.rozetta.jp/lp/thereading/instruction/",
          "requiresAuth": true,
          "invalid_domains": ["t-3mt"]
        },
        {
          "icon": "mdi-phone",
          "title": "telephone",
          "route": "",
          "link": "tel:0120-934610",
          "invalid_domains": []
        },
        {
          "icon": "mdi-email",
          "title": "mail",
          "route": "",
          "link": "mailto:cs-support@rozetta.jp",
          "invalid_domains": []
        },
      ];
    }
  },
  methods: {
    cancel() {
      this.support_dialog = false;
    },
    popup: (url)=> {
      window.open(url, '_target');
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-contents {
  position: fixed;
  bottom: 40px;
  left: 8px;
  background: gray;
  z-index: 200;
}
.dialog-btn {
  background: gray !important;
  box-shadow: none;
  font-size: 12px;
}
.dialog-close {
  width: 20px;
  position: relative;
  right: -4px;
  cursor: pointer;
}
</style>
